<template>
  <ContactUsComponent
    :is-visible="showContactModal"
    @close="closeContactModal"
  />
  <div class="wrapper-other-services">
    <MenuComponent
      logoUrl="assets/logos/LogoYellow.svg"
      textColor="var(--yellow)"
      menuIcon="assets/icons/MenuYellow.svg"
      closeIcon="assets/icons/CloseYellow.svg"
    />

    <div class="first-info">
      <p>Tenemos múltiples servicios para ti</p>
      <GenericButton
        text="Agenda una llamada"
        backgroundColor="var(--yellow)"
        textColor="var(--white)"
        shadowType="dark"
        @click="openContactModal"
      />
    </div>

    <div class="content-block">
      <div class="content-block-container">
        <div class="wrapper-video">
          <video
            class="video"
            autoplay
            muted
            loop
            playsinline
            disablepictureinpicture
            controlslist="nodownload nofullscreen noremoteplayback"
          >
            <source
              src="assets/other-services/Video1.mp4"
              type="video/mp4"
            />
          </video>
        </div>

        <div class="wrapper-information">
          <div class="information">
            <p class="title">PRODUCCIÓN MUSICAL Y AUDIOVISUAL</p>
            <p class="text">
              Creamos Music Content para artistas y proyectos musicales:
              videoclips, live sessions y piezas visuales pensadas para lanzar,
              posicionar y escalar tu música
            </p>
          </div>
        </div>
      </div>
    </div>

    <div class="content-block-rvs">
      <div class="content-block-container-rvs">
        <div class="wrapper-video-rvs">
          <video
            class="video-rvs"
            autoplay
            muted
            loop
            playsinline
            disablepictureinpicture
            controlslist="nodownload nofullscreen noremoteplayback"
          >
            <source
              src="assets/other-services/Video2.mp4"
              type="video/mp4"
            />
          </video>
        </div>

        <div class="wrapper-information-rvs">
          <div class="information-rvs">
            <p class="title-rvs">SERVICIOS DE DRONE</p>
            <p class="text-rvs">
              Capturas aéreas que documentan espacios, recorridos y contextos
              reales para campañas, proyectos y comunicación corporativa
            </p>
          </div>
        </div>
      </div>
    </div>

    <div class="content-block">
      <div class="content-block-container">
        <div class="wrapper-video">
          <video
            class="video"
            autoplay
            muted
            loop
            playsinline
            disablepictureinpicture
            controlslist="nodownload nofullscreen noremoteplayback"
          >
            <source
              src="assets/other-services/Video3.mp4"
              type="video/mp4"
            />
          </video>
        </div>

        <div class="wrapper-information">
          <div class="information">
            <p class="title">FOTOGRAFÍA Y VIDEO 360</p>
            <p class="text">
              Contenido que muestra espacios y productos completos, permitiendo
              al usuario entender exactamente qué va a encontrar antes de elegir
            </p>
          </div>
        </div>
      </div>
    </div>

    <div class="content-block-rvs">
      <div class="content-block-container-rvs">
        <div class="wrapper-video-rvs">
          <video
            class="video-rvs"
            autoplay
            muted
            loop
            playsinline
            disablepictureinpicture
            controlslist="nodownload nofullscreen noremoteplayback"
          >
            <source
              src="assets/other-services/Video4.mp4"
              type="video/mp4"
            />
          </video>
        </div>

        <div class="wrapper-information-rvs">
          <div class="information-rvs">
            <p class="title-rvs">CUBRIMIENTO DE EVENTOS</p>
            <p class="text-rvs">
              Registro estratégico de momentos clave para que tu evento se
              convierta en contenido reutilizable que extiende su impacto más
              allá del día en que ocurre
            </p>
          </div>
        </div>
      </div>
    </div>

    <div class="content-block">
      <div class="content-block-container">
        <div class="wrapper-video">
          <video
            class="video"
            autoplay
            muted
            loop
            playsinline
            disablepictureinpicture
            controlslist="nodownload nofullscreen noremoteplayback"
          >
            <source
              src="assets/other-services/Video5.mp4"
              type="video/mp4"
            />
          </video>
        </div>

        <div class="wrapper-information">
          <div class="information">
            <p class="title">EVENTOS SOCIALES</p>
            <p class="text">
              Contenido que muestra espacios y productos completos, permitiendo
              registro visual de momentos reales para que puedan compartirse,
              documentarse y conservarse con claridad en el tiempo
            </p>
          </div>
        </div>
      </div>
    </div>

    <FooterComponent overlayColor="var(--yellow)" />
  </div>
</template>

<script>
import MenuComponent from "@/ux/layout/components/MenuComponent.vue";
import FooterComponent from "@/ux/layout/components/FooterComponent.vue";
import GenericButton from "../../components/commons/controls/GenericButton.vue";
import ContactUsComponent from "../sharedComponents/ContactUsComponent.vue";
import { contactUsUse } from "../sharedComponents/use/contactUsUse";

export default {
  name: "OtherServicesView",
  components: {
    MenuComponent,
    FooterComponent,
    GenericButton,
    ContactUsComponent,
  },

  setup() {
    const { showContactModal, openContactModal, closeContactModal } =
      contactUsUse();

    return {
      showContactModal,
      openContactModal,
      closeContactModal,
    };
  },
};
</script>

<style scoped lang="scss">
@import "src/ux/otherServices/styles/otherServicesStyle";
</style>